import { gameColors, metalPanel, copperButton } from '@/shared/ui/game-theme';
import type { CharacterLanguage } from '../utils/character-labels';
export function CharacterScale({ label, value, poles, language }: {
  label: string; value: number; poles: readonly [string, string]; language: CharacterLanguage;
}) {
  const level = Math.max(0, Math.min(100, Number.isFinite(value) ? value : 50));
  const balance = language === 'ru' ? 'Между полюсами' : 'Between the poles';
  const description = level < 35 ? poles[0] : level > 65 ? poles[1] : balance;
  return <div className="character-scale">
    <div className="character-scale-track" style={{ background: metalPanel.background, boxShadow: metalPanel.boxShadow, border: metalPanel.border }} role="meter" aria-label={label}
      aria-valuemin={0} aria-valuemax={100} aria-valuenow={level}
      aria-valuetext={description}>
      <span className="character-scale-midpoint" aria-hidden="true" />
      <span className="character-scale-thumb" style={{ left: `${level}%`, background: copperButton.background, borderColor: gameColors.copper, boxShadow: copperButton.boxShadow }} aria-hidden="true" />
    </div>
    <div className="character-scale-poles" style={{ color: gameColors.muted }} aria-hidden="true"><span>{poles[0]}</span><span>{poles[1]}</span></div>
  </div>;
}
